module.exports = __webpack_public_path__ + "static/media/lu-mono.58899fe3.png";